import { makeContextualPopupApi } from '../utils/plugin'
import toast from '../managers/toast'

export default makeContextualPopupApi('toast', toast)
